var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { PrivateKeyType, } from '@interfaces/keys.interface';
import { addCaptionToLoading, addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { closeModal, openModal } from '@popup/multichain/actions/modal.actions';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { MultisigUtils } from '@popup/steem/utils/multisig.utils';
import ProxyUtils from '@popup/steem/utils/proxy.utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { MetadataPopup } from 'src/common-ui/metadata-popup/metadata-popup.component';
const ProxyTab = ({ activeAccount, refreshActiveAccount, setErrorMessage, setSuccessMessage, addToLoadingList, removeFromLoadingList, addCaptionToLoading, openModal, closeModal, }) => {
    const [proxyUsername, setProxyUsername] = useState('');
    const [keyType, setKeyType] = useState();
    useEffect(() => {
        if (activeAccount) {
            setKeyType(KeysUtils.getKeyType(activeAccount.keys.active, activeAccount.keys.activePubkey, activeAccount.account, activeAccount.account, KeychainKeyTypesLC.active));
        }
    }, [activeAccount]);
    const processSetAsProxy = (options) => __awaiter(void 0, void 0, void 0, function* () {
        addToLoadingList('popup_html_setting_proxy', keyType);
        try {
            const success = yield ProxyUtils.setAsProxy(proxyUsername, activeAccount.name, activeAccount.keys.active, options);
            if (success) {
                if (success.isUsingMultisig) {
                    setSuccessMessage('multisig_transaction_sent_to_signers');
                }
                else {
                    setSuccessMessage('popup_success_proxy', [proxyUsername]);
                    refreshActiveAccount();
                }
            }
            else {
                setErrorMessage('html_popup_set_as_proxy_error');
            }
        }
        catch (err) {
            setErrorMessage(err.message);
        }
        finally {
            removeFromLoadingList('popup_html_setting_proxy');
        }
    });
    const handleClickOnSetAsProxy = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!activeAccount.keys.active) {
            setErrorMessage('html_popup_proxy_requires_active_key');
        }
        if (keyType === PrivateKeyType.MULTISIG) {
            const twoFaAccounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, KeychainKeyTypes.active);
            let initialMetadata = {};
            for (const account of twoFaAccounts) {
                if (!initialMetadata.twoFACodes)
                    initialMetadata.twoFACodes = {};
                initialMetadata.twoFACodes[account] = '';
            }
            if (twoFaAccounts.length > 0) {
                openModal({
                    title: 'popup_html_transaction_metadata',
                    children: (React.createElement(MetadataPopup, { initialMetadata: initialMetadata, onSubmit: (metadata) => {
                            addCaptionToLoading('multisig_transmitting_to_2fa');
                            processSetAsProxy({ metaData: metadata });
                            closeModal();
                        }, onCancel: () => closeModal() })),
                });
            }
        }
        else {
            processSetAsProxy();
        }
    });
    const processRemoveProxy = (options) => __awaiter(void 0, void 0, void 0, function* () {
        addToLoadingList('popup_html_clearing_proxy', keyType);
        try {
            const success = yield ProxyUtils.removeProxy(activeAccount.name, activeAccount.keys.active, options);
            if (success) {
                if (success.isUsingMultisig) {
                    setSuccessMessage('multisig_transaction_sent_to_signers');
                }
                else {
                    refreshActiveAccount();
                    setSuccessMessage('bgd_ops_unproxy', [`@${proxyUsername}`]);
                }
            }
            else {
                setErrorMessage('html_popup_clear_proxy_error');
            }
        }
        catch (err) {
            setErrorMessage(err.message);
        }
        finally {
            removeFromLoadingList('popup_html_clearing_proxy');
        }
    });
    const handleClickOnRemoveProxy = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!activeAccount.keys.active) {
            setErrorMessage('html_popup_proxy_requires_active_key');
        }
        if (keyType === PrivateKeyType.MULTISIG) {
            const twoFaAccounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, KeychainKeyTypes.active);
            let initialMetadata = {};
            for (const account of twoFaAccounts) {
                if (!initialMetadata.twoFACodes)
                    initialMetadata.twoFACodes = {};
                initialMetadata.twoFACodes[account] = '';
            }
            if (twoFaAccounts.length > 0) {
                openModal({
                    title: 'popup_html_transaction_metadata',
                    children: (React.createElement(MetadataPopup, { initialMetadata: initialMetadata, onSubmit: (metadata) => {
                            addCaptionToLoading('multisig_transmitting_to_2fa');
                            processSetAsProxy({ metaData: metadata });
                            closeModal();
                        }, onCancel: () => closeModal() })),
                });
            }
        }
        else {
            processRemoveProxy();
        }
    });
    return (React.createElement("div", { "data-testid": "proxy-tab", className: "proxy-tab" },
        React.createElement("div", { className: "introduction" }, getMessage(activeAccount.account.proxy.length > 0
            ? 'html_popup_witness_has_proxy'
            : 'html_popup_witness_proxy_definition')),
        activeAccount.account.proxy.length > 0 && (React.createElement("div", { "data-testid": "proxy-name", className: "proxy-name" }, getMessage('html_popup_currently_using_proxy', [
            activeAccount.account.proxy,
        ]))),
        activeAccount.account.proxy.length === 0 && (React.createElement(InputComponent, { dataTestId: "input-username", value: proxyUsername, onChange: setProxyUsername, logo: SVGIcons.INPUT_AT, placeholder: "popup_html_proxy", type: InputType.TEXT })),
        React.createElement("div", { className: "fill-space" }),
        activeAccount.account.proxy.length === 0 && (React.createElement(OperationButtonComponent, { dataTestId: "operation-set-as-proxy-button", requiredKey: KeychainKeyTypesLC.active, label: 'html_popup_set_as_proxy', onClick: () => handleClickOnSetAsProxy() })),
        activeAccount.account.proxy.length > 0 && (React.createElement(OperationButtonComponent, { dataTestId: "operation-clear-proxy", requiredKey: KeychainKeyTypesLC.active, label: 'html_popup_clear_proxy', onClick: () => handleClickOnRemoveProxy() }))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    refreshActiveAccount,
    setErrorMessage,
    setSuccessMessage,
    addToLoadingList,
    removeFromLoadingList,
    addCaptionToLoading,
    openModal,
    closeModal,
});
export const ProxyTabComponent = connector(ProxyTab);
